import { IAttachedFile } from '../../../redux/types/IAttachedFile';
import IFile from '../../../redux/types/IFiles';
import { StorageService } from '../../services/StorageService';
import { ContainerDetailsWindow } from './ContainerDetailsWindow';
import {
    ERROR_OBTAINING_SAS, ERROR_UPLOADING_FILE_SAS,
    OBTAINED_SAS,
    REQUEST_SAS,
    UPLOADING_FILE_SAS, UPLOAD_COMPLETED
} from './ContainerDetailsWindowFields';

export class UploadCueSheetsContainerDetailsWindow extends ContainerDetailsWindow {

    onDownloadFile(data: any): void {
        if (data.isDirectory) return;

        StorageService.downloadFile(data.fullName, false, data.name)
            .then((downloadLink: string) => {
                if (downloadLink?.length > 0) {
                    const link = document.getElementById("downloadLinkDataIngestion");
                    if (link) {
                        link.setAttribute('href', downloadLink);
                        link.click();
                        link.removeAttribute('href');
                    }
                }
            });
    }

    uploadFile(newFile: IFile, path: string, file: any) {
        const {
            addFileToUpload,
            setProgressUploadFileProccess,
            setInDropZone,
            currentUserNameNumber
        } = this.props;
		
        addFileToUpload(newFile, true);

        setInDropZone(false);

        setProgressUploadFileProccess(this.viewData[REQUEST_SAS], newFile, false);

        return Promise.resolve(
            StorageService.getUploadUri(path, false).then(
                (uri: string) => {
                    if (!uri || uri.length === 0) {
                        setProgressUploadFileProccess(this.viewData[ERROR_OBTAINING_SAS], newFile, true);
                        return false;
                    }
                    
                    setProgressUploadFileProccess(this.viewData[OBTAINED_SAS], newFile, false);
                    setProgressUploadFileProccess(this.viewData[UPLOADING_FILE_SAS], newFile, false);

                    return StorageService.uploadFile(uri, file, currentUserNameNumber, 'Portal Cue Sheet', file.name).then(
                        (res: boolean) => {
                            if (res) {
                                setProgressUploadFileProccess(this.viewData[UPLOAD_COMPLETED], newFile, true);
                                return true;
                            }
                        },
                        reject => {
                            setProgressUploadFileProccess(this.viewData[ERROR_UPLOADING_FILE_SAS], newFile, true);

                            return false;
                        }
                    )
                    .catch(error => {
                        return false;
                    })
                },
                reject => {
                    setProgressUploadFileProccess(this.viewData[ERROR_OBTAINING_SAS], newFile, true);
                    return false;
                }
            )
        )
    }

    handleDrop = e => {
        const {
            cleanUploadFilesState,
            addRepertoireAttachmentToState,
            removeAttachmentIfExists,
            entitySource,
            currentUserNameNumber
        } = this.props;

        const files = [...e.dataTransfer.files];

        cleanUploadFilesState();

        files.forEach(file => {

            const newFile: IFile = super.createUploadFile(file);
            const fileToUpload: IFile = { ...newFile };
            fileToUpload.name = crypto.randomUUID();
            
            const fullPath = `repertoire/portalcues/input/${currentUserNameNumber}_${file.name}`;

            this.uploadFile(newFile, fullPath, file).then(
                (uploaded: boolean) => {
                    const finalFile: IAttachedFile = {
                        fileName: file.name,
                        guid: fileToUpload.name
                    };
                    if (!uploaded) {
                        removeAttachmentIfExists(finalFile, entitySource);
                    }
                    else {
                        addRepertoireAttachmentToState(finalFile);
                    }
                }
            )
        });

        e.preventDefault();
    };
}